import React, { Fragment } from "react";
import Portada from "./Portada";

const Inicio = () => {
  return (
    <Fragment>
        <Portada></Portada>
    </Fragment>
  );
};

export default Inicio;
